
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../pages/chat/api";
import Cookies from "js-cookie";
import { getFreshAccessToken } from "../pages/chat/api";
let activeChatSocket = null;
let shouldStopStreaming = false;
export const fetchChatContract = createAsyncThunk(
  
  "chatContract/fetchChatContract",
  async ({ contractKey, clientMessage,chat_module = "contract", id }, { dispatch, rejectWithValue }) => {
    
    shouldStopStreaming = false;
    let token = await getFreshAccessToken();
    if (!token) {
      return rejectWithValue("No authorization token found");
    }
    const wsUrl = `wss://stagingbackend.docusensa.com/ws/qdrant-chat/${contractKey}/?token=${token}`;

    // const wsUrl = `wss://stagingbackend.docusensa.com/ws/qdrant-chat-contract/${contractKey}/?token=${token}`;
    shouldStopStreaming = false;
if (activeChatSocket && activeChatSocket.readyState !== WebSocket.CLOSED) {
  activeChatSocket.close();
}


    const socket = new WebSocket(wsUrl);
    activeChatSocket = socket; 

    return new Promise((resolve, reject) => {
      let accumulatedAnswer = "";
      let botMessageId = null;
      let runId = null;
      let generatedQuestions = null;

      socket.onopen = () => {
        socket.send(JSON.stringify({ client_message: clientMessage,chat_module: chat_module, id }));
        dispatch(updateStatus("loading"));
        dispatch(updatePartialAnswer(""));
      };

      socket.onmessage = (event) => {
    if (shouldStopStreaming) {
  console.warn("🛑 shouldStopStreaming is true → Closing WebSocket...");
  socket.close();
  dispatch(updateStatus("stopped")); // Optional UI update
  return;
}

        try {
          const data = JSON.parse(event.data);

          if (
            data.type !== "info" &&
            data.status !== "connected" &&
            data.message
          ) {
            accumulatedAnswer += data.message;
            dispatch(updatePartialAnswer(accumulatedAnswer));
          }

          if (data.type === "final") {
          const sources = data.data.sources || []; 
            botMessageId = data.data.bot_message_id;
            runId = data.data.run_id;
            generatedQuestions = data.data.generated_questions
            || ""; 
          
           

          
            // Extract user initials
            const firstChar = data.data.first_char || "";
            const lastChar = data.data.last_char || "";
            const userInitials = (firstChar + lastChar).trim().toUpperCase() || "N/A";
            
          
           
          
            // Dispatch data to Redux
dispatch(updateFinalAnswer(data.data.answer));
            dispatch(updateBotMessageInfo({ botMessageId, runId, generatedQuestions, sources  }));
          
            dispatch(updateStatus("succeeded"));
            socket.close();
            resolve(accumulatedAnswer);
          }
          
        } catch (error) {
          console.error("Error parsing WebSocket message:", event.data, error);
        }
      };

      socket.onerror = (error) => {
        console.error("WebSocket error:", error);
        reject(rejectWithValue("WebSocket connection error"));
      };

      socket.onclose = () => {
      };
    });
  }
);

export const fetchContractSummary = createAsyncThunk(
  "chatContract/fetchContractSummary ",
  async ({ contractKey, clientMessage,chat_module = "contract" }, { dispatch, rejectWithValue }) => {
    shouldStopStreaming = false;
    let token = await getFreshAccessToken();
if (!token) {
  return rejectWithValue("No authorization token found");
}

    const wsUrl = `wss://stagingbackend.docusensa.com/ws/pdf-summary-and-chats/${contractKey}/?token=${token}`;

    const socket = new WebSocket(wsUrl);
    dispatch(updateWebSocketStatus("connecting"));

    return new Promise((resolve, reject) => {
      let accumulatedAnswer = "";
      let botMessageId = null;
      let runId = null;
      let generatedQuestions = null;

      socket.onopen = () => {
        dispatch(updateWebSocketStatus("connected"));
        
        dispatch(updateSummaryWebSocketStatus(true));
        socket.send(JSON.stringify({ client_message: clientMessage,chat_module: chat_module }));
        dispatch(updateStatus("loading"));
        dispatch(updatePartialAnswer(""));
        
      };

      socket.onmessage = (event) => {
     
        try {
          const data = JSON.parse(event.data);

          if (
            data.type !== "info" &&
            data.status !== "connected" &&
            data.message
          ) {
            accumulatedAnswer += data.message;
            dispatch(updatePartialAnswer(accumulatedAnswer));
          }

          if (data.type === "final") {
            dispatch(updateSummaryWebSocketStatus(false));
            botMessageId = data.data.bot_message_id;
            runId = data.data.run_id;
            const summary = data.data.summary; // Add this

            dispatch(updateFinalSummary(summary));
            generatedQuestions = data.data.example_questions || "";
            dispatch(updateSummaryStatus("succeeded"));

            let formattedTimestamp = "N/A";  // Default fallback

            if (data.data.summary_generated_at) {
              try {
                formattedTimestamp = new Date(data.data.summary_generated_at).toLocaleString("en-US", {
                  month: "short",
                  day: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                });
              } catch (error) {
                console.error("Error parsing summary_generated_at:", error);
              }
            }
            
          
            // Extract user initials
            const firstChar = data.data.first_char || "";
            const lastChar = data.data.last_char || "";
            const userInitials = (firstChar + lastChar).trim().toUpperCase() || "N/A";
            
          
       
          
            dispatch(updateGeneratedQuestions(generatedQuestions)); // Update the state with the summary
            dispatch(
              updateBotMessageInfo({ botMessageId, runId, generatedQuestions })
            );
            dispatch(updateSummaryMetadata({ formattedTimestamp, userInitials }));

            dispatch(updateStatus("succeeded"));
            if (generatedQuestions) {
              dispatch(updateSummaryStatus("completed"));
          }
            socket.close();
            dispatch(updateWebSocketStatus("closed"));

            resolve(summary);
          }
        } catch (error) {
          console.error("Error parsing WebSocket message:", event.data, error);
        }
      };

      socket.onerror = (error) => {
        console.error("WebSocket error:", error);
        dispatch(updateWebSocketStatus("error"));
        reject(rejectWithValue("WebSocket connection error"));
      };

      socket.onclose = () => {

        dispatch(updateWebSocketStatus("closed"));

      };
    });
  }
);

const chatContractSlice = createSlice({
  name: "chatContract",
  initialState: {
    messages: [],
    partialAnswer: "",
    finalAnswer: "",
    partialSummary: "",
    finalSummary: "", 
    status: "idle",
    summaryStatus: "idle",
    error: null,
    summaryError: null,
    botMessageId: null,
    runId: null,
    generatedQuestions: null,
    feedback: {},
    formattedTimestamp: "",
    userInitials: "",
    isSummaryWebSocketActive: true,
    webSocketStatus: "idle",
    
  },

  reducers: {
    resetChatContractState: (state) => {
      state.messages = [];
      state.partialAnswer = "";
      state.finalAnswer = "";
      state.status = "idle";
      state.summaryStatus = "idle";
      state.error = null;
      state.botMessageId = null;
      state.runId = null;
     
      
    },
    updateWebSocketStatus: (state, action) => {
      state.webSocketStatus = action.payload;
    },
    updatePartialAnswer: (state, action) => {
      state.partialAnswer = action.payload;
    },
    updateFinalAnswer: (state, action) => {
      state.finalAnswer = action.payload;
    },
    updateBotMessageInfo: (state, action) => {
      const { botMessageId, runId, generatedQuestions, sources } = action.payload;
      state.botMessageId = botMessageId;
      state.runId = runId;
      state.generatedQuestions = generatedQuestions;
      state.sources = sources || [];
    },
    updateStatus: (state, action) => {
      state.status = action.payload;
    },
    updateGeneratedQuestions: (state, action) => {
      state.generatedQuestions = action.payload;
    },
    updatePartialSummary: (state, action) => {
      state.partialSummary = action.payload;
    },
    updateFinalSummary: (state, action) => {
      state.finalSummary = action.payload;
    },
    updateSummaryStatus: (state, action) => {
      state.summaryStatus = action.payload;
    },
    updateSummaryMetadata: (state, action) => {
    
      if (action.payload) {
        state.formattedTimestamp = action.payload.formattedTimestamp ? action.payload.formattedTimestamp : "N/A";
        state.userInitials = action.payload.userInitials ? action.payload.userInitials : "N/A";
      }
    },
    
    updateSummaryWebSocketStatus: (state, action) => {
      state.isSummaryWebSocketActive = action.payload;
    },
    resetStopStreaming: (state) => {
    shouldStopStreaming = false;
  },
  stopStreaming: (state) => {
  shouldStopStreaming = true;
}

    
  
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatContract.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchChatContract.fulfilled, (state, action) => {
        state.messages.push({
          answer: action.payload,
          botMessageId: state.botMessageId,
          runId: state.runId,
        });
        state.status = "succeeded";
      })
      .addCase(fetchContractSummary.pending, (state) => {
        state.summaryStatus = "loading";
      })
      .addCase(fetchContractSummary.fulfilled, (state) => {
        state.summaryStatus = "succeeded";
      })
      .addCase(fetchContractSummary.rejected, (state, action) => {
        state.summaryError = action.payload;
        state.summaryStatus = "failed";
      })
      .addCase(fetchChatContract.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
      });
  },
});

export const {
  resetChatContractState,
  updateWebSocketStatus,
  updatePartialAnswer,
  updatePartialSummary,
  updateFinalSummary,
  updateSummaryStatus,
  updateGeneratedQuestions,
  updateFinalAnswer,
  updateBotMessageInfo,
  updateStatus,
  updateSummaryMetadata,
  updateSummaryWebSocketStatus,
  resetStopStreaming,
  stopStreaming,
} = chatContractSlice.actions;
export default chatContractSlice.reducer;